import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'et-participant-header',
    templateUrl: './participant-header.component.html',
    styleUrls: ['./participant-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ParticipantHeaderComponent {

    @Input()
    public header: string;

    @Input()
    public subHeader: string;

    @Input()
    public inProgressCount: number;

    @Input()
    public publishedCount: number;

    @Output()
    public readonly inProgressSelected = new EventEmitter();

    @Output()
    public readonly publishedSelected = new EventEmitter();

    public showInProgressOnly = true;

    public showPublishedOnly = false;

    public showInProgress(): void {
        this.showInProgressOnly = true;
        this.showPublishedOnly = false;
        this.inProgressSelected.emit();
    }

    public showPublished(): void {
        this.showInProgressOnly = false;
        this.showPublishedOnly = true;
        this.publishedSelected.emit();
    }
}
